<template>
<app-content-admin>
  <template slot="header">{{$t("M00013")}}</template>

  <v-layout row wrap>
        <v-flex xs12 lg6 mx-auto>
            <v-card>
                <v-card-text>
                    <v-card-title>
                        {{ $t('member_detail') }}
                    </v-card-title>
                    <v-form @submit.prevent="updateProfile">
                        <v-container>
                            <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field :label="$t('name')" v-model="form.name" outlined></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field :label="$t('email')" v-model="form.email" outlined></v-text-field>
                            </v-flex>
                            
                            <v-flex xs12>
                                <v-text-field
                                    :label="$t('mobile')"
                                    v-model="form.mobile_no"
                                    :rules="[rules.required('mobile_no')]"
                                    outlined
                                    prefix="+60"
                                >
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 class="text-right">
                                <v-btn color="primary" type="submit">{{$t('submit')}}</v-btn>
                            </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
</app-content-admin>

</template>

<script>
import vForm from '@/mixins/vForm';

export default{
    mixins: [vForm],

    data(){
        return {
            form: {
                id:'',
                name : '',
                email : '',
                mobile_no : '',
            },
        }
    },

    components : {

    },

    created() {
        this.getUserDetail();
    },
    methods: {

        getUserDetail() {
            let loader = this.$loading.show();

            axios.get(api.path('member.detail', {id: this.$route.params.user_id}))
                .then(response => response.data)
                    .then(response => {

                this.form = response.data

                loader.hide();
            }).catch(response => {
                loader.hide();
                this.toastr.e(response.message);
            });
        },

        updateProfile() {
            this.form.date_of_birth = moment(this.form.date_of_birth).format('YYYY-MM-DD');

            if(this.form.name == null || this.form.name.length < 1)
            {
                this.$toastr.e(this.$t('P00113'));
            }
            else
            {
                let loader = this.$loading.show();

                axios.post('/api/admin/member/updateUser', this.form)
                .then(response => response.data)
                .then(response => {
                    console.log(response)
                    this.$toastr.s(response.message);
                    loader.hide();
                }).catch(response => {
                    this.$toastr.e(response.message);
                    loader.hide();
                });
            }
        },
        getCountryList()
        {
            axios.get(api.path('core.countries'))
                .then(response => response.data)
                .then(response => {
                    
                let rowtables = response.countries;
                this.countryCode = rowtables.map((item) => {
                    return {
                        name: this.$t(item.localize)+" +"+item.country_code,
                        code: (item.country_code).toString(),
                        id: item.id
                    };
                });
                this.country = rowtables.map((item) => {
                    return {
                        name: this.$t(item.localize),
                        id: item.id
                    };
                });
            });
        },
        changePassword() 
        {
            let loader = this.$loading.show();

            axios.post(api.path('member.reset_pwd'), {"user_id":this.form.user_id, "type":"login"})
                .then(response => response.data)
                .then(response => {
                this.$toastr.s(response.message);
                this.newpassword = response.message+': '+response.new;
                loader.hide();
            }).catch(response => {
                loader.hide()
                this.$toastr.e(response.message);
            });
        },
        changeTransPassword() 
        {
            let loader = this.$loading.show();

            axios.post(api.path('member.reset_pwd'), {"user_id":this.form.user_id, "type":"transaction"})
            .then(response => response.data)
            .then(response => {
                this.$toastr.s(response.message);
                this.newTransPassword = response.message+': '+response.new;
                loader.hide();
            }).catch(response => {
                loader.hide()
                this.$toastr.e(response.message);
            });
        },
    }
}
</script>
